import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _class, _Legend;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.regexp.exec.js";
import { observer } from "mobx-react";
import { Component, Fragment } from "react";
import defined from "terriajs-cesium/Source/Core/defined";
import Resource from "terriajs-cesium/Source/Core/Resource";
import URI from "urijs";
import isDefined from "../../../Core/isDefined";
import { getMakiIcon } from "../../../Map/Icons/Maki/MakiIcons";
import MinMaxLevelMixin from "../../../ModelMixins/MinMaxLevelMixin";
import TableMixin from "../../../ModelMixins/TableMixin";
import proxyCatalogItemUrl from "../../../Models/Catalog/proxyCatalogItemUrl";
import hasTraits from "../../../Models/Definition/hasTraits";
import Button from "../../../Styled/Button";
import Icon, { StyledIcon } from "../../../Styled/Icon";
import LegendOwnerTraits from "../../../Traits/TraitsClasses/LegendOwnerTraits";
import Styles from "./legend.scss";

/* A lookup map for displayable mime types */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const DISPLAYABLE_MIME_TYPES = ["image/jpeg", "image/gif", "image/png", "image/svg+xml", "image/bmp", "image/x-bmp"].reduce((acc, mimeType) => {
  acc[mimeType] = true;
  return acc;
}, {});
const IMAGE_URL_REGEX = /[./](png|jpg|jpeg|gif|svg)/i;
function checkMimeType(legend) {
  var _legend$url;
  return legend.urlMimeType && !!DISPLAYABLE_MIME_TYPES[legend.urlMimeType] || !!((_legend$url = legend.url) !== null && _legend$url !== void 0 && _legend$url.match(IMAGE_URL_REGEX));
}
let Legend = observer(_class = (_Legend = class Legend extends Component {
  onImageLoad(evt, legend) {
    var _legend$imageScaling;
    const image = evt.target;
    image.style.display = "none";
    image.style.maxWidth = "none";
    if (evt.type === "error") {
      return;
    }
    image.style.display = "initial";

    // If legend need scaling, this is the only way to do it :/
    // See https://stackoverflow.com/questions/7699621/display-image-at-50-of-its-native-size
    // or https://stackoverflow.com/questions/35711807/display-high-dpi-image-at-50-scaling-using-just-css

    image.style.width = "".concat(((_legend$imageScaling = legend.imageScaling) !== null && _legend$imageScaling !== void 0 ? _legend$imageScaling : 1) * image.offsetWidth, "px");
    // Must set maxWidth *after* setting width, as it may change offsetWidth
    image.style.maxWidth = "100%";
  }
  renderLegend(legend, i) {
    if (defined(legend.url)) {
      return this.renderImageLegend(legend, i);
    } else if (defined(legend.items)) {
      return this.renderGeneratedLegend(legend, i);
    }
    return null;
  }
  renderImageLegend(legend, _i) {
    const isImage = checkMimeType(legend);
    // const insertDirectly = !!legend.safeSvgContent; // we only insert content we generated ourselves, not arbitrary SVG from init files.

    // const svg = legend.safeSvgContent;
    // // Safari xlink NS issue fix
    // const processedSvg = svg ? svg.replace(/NS\d+:href/gi, "xlink:href") : null;
    // const safeSvgContent = { __html: processedSvg };

    /* We proxy the legend so it's cached, and so that the Print/Export feature works with non-CORS servers.
     * We make it absolute because the print view is opened on a different domain (about:blank) so relative
     * URLs will not work.
     */
    const proxiedUrl = isDefined(legend.url) ? makeAbsolute(proxyCatalogItemUrl(this.props.item, legend.url)) : undefined;

    // padding-top: 8px;
    // padding-bottom: 8px;

    // if (isImage && insertDirectly) {
    //   return (<li
    //     key={i}
    //     className={Styles.legendSvg}
    //     dangerouslySetInnerHTML={safeSvgContent}
    //   />)
    // }

    if (!isDefined(proxiedUrl)) return null;
    if (isImage) {
      return /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(_StyledA, {
          href: proxiedUrl,
          className: Styles.imageAnchor,
          target: "_blank",
          rel: "noreferrer noopener",
          $_css: legend.backgroundColor,
          children: /*#__PURE__*/_jsx("img", {
            src: proxiedUrl
            // Set maxWidth to 100% if no scaling required (otherwise - see onImageLoad)
            ,
            style: {
              maxWidth: !isDefined(legend.imageScaling) || legend.imageScaling === 1 ? "100%" : undefined
            },
            onError: evt => this.onImageLoad.bind(this, evt, legend)(),
            onLoad: evt => this.onImageLoad.bind(this, evt, legend)()
          })
        })
      }, proxiedUrl);
    }
    return /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx("a", {
        href: proxiedUrl,
        target: "_blank",
        rel: "noreferrer noopener",
        className: Styles.legendOpenExternally,
        children: "Open legend in a separate tab"
      })
    }, proxiedUrl);
  }
  renderGeneratedLegend(legend, i) {
    if (isDefined(legend.items) && legend.items.length > 0) {
      return /*#__PURE__*/_jsx("li", {
        className: Styles.generatedLegend,
        children: /*#__PURE__*/_jsx(_StyledTable, {
          $_css2: legend.backgroundColor,
          children: /*#__PURE__*/_jsx("tbody", {
            children: legend.items.map(this.renderLegendItem.bind(this))
          })
        })
      }, i);
    }
    return null;
  }
  renderLegendItem(legendItem, i) {
    let imageUrl = legendItem.imageUrl;
    if (legendItem.marker) {
      var _getMakiIcon, _legendItem$color;
      imageUrl = (_getMakiIcon = getMakiIcon(legendItem.marker, (_legendItem$color = legendItem.color) !== null && _legendItem$color !== void 0 ? _legendItem$color : "#fff",
      // We have to have a fallback color here for `getMakiIcon`
      legendItem.outlineWidth, legendItem.outlineColor, legendItem.imageHeight, legendItem.imageWidth)) !== null && _getMakiIcon !== void 0 ? _getMakiIcon :
      // If getMakiIcons returns nothing, we assume legendItem.marker is a URL
      legendItem.marker;
    }

    // Set boxStyle border to solid black if we aren't showing an image AND this legend item has space above it
    let boxStyle = {
      border: !imageUrl && legendItem.addSpacingAbove ? "1px solid black" : undefined
    };

    // Override the boxStyle border if we have outlineColor and outlineWidth defined for this legend item
    if (!imageUrl && legendItem.outlineColor && legendItem.outlineWidth) {
      var _legendItem$outlineSt;
      boxStyle.border = "".concat(legendItem.outlineWidth, "px ").concat((_legendItem$outlineSt = legendItem.outlineStyle) !== null && _legendItem$outlineSt !== void 0 ? _legendItem$outlineSt : "solid", " ").concat(legendItem.outlineColor);
    }
    let boxContents;

    // Browsers don't print background colors by default, so we render things a little differently.
    // Chrome and Firefox let you override this, but not IE and Edge. So...
    if (this.props.forPrint) {
      if (imageUrl) {
        var _legendItem$rotation;
        boxContents = /*#__PURE__*/_jsx("img", {
          width: "20px",
          height: "16px",
          src: imageUrl,
          style: {
            transform: "rotate(".concat((_legendItem$rotation = legendItem.rotation) !== null && _legendItem$rotation !== void 0 ? _legendItem$rotation : 0, "deg)")
          }
        });
      } else {
        boxContents = /*#__PURE__*/_jsx(_Fragment, {
          children: "\u25A0"
        });
        boxStyle = _objectSpread({
          color: legendItem.color,
          fontSize: "48px",
          lineHeight: "16px"
        }, boxStyle);
      }
    } else {
      if (imageUrl || legendItem.marker) {
        boxStyle = _objectSpread({
          transform: "rotate(".concat(legendItem.rotation, "deg)"),
          backgroundImage: "url(".concat(imageUrl, ")"),
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "24px",
          width: "".concat(legendItem.imageWidth, "px")
        }, boxStyle);
      } else {
        boxStyle = _objectSpread({
          backgroundColor: legendItem.color,
          minWidth: "20px"
        }, boxStyle);
      }
    }
    const rowStyle = {
      height: "".concat(legendItem.imageHeight + 2, "px")
    };
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [legendItem.addSpacingAbove && /*#__PURE__*/_jsx("tr", {
        className: Styles.legendSpacer,
        children: /*#__PURE__*/_jsx("td", {})
      }), /*#__PURE__*/_jsxs("tr", {
        style: rowStyle,
        children: [/*#__PURE__*/_jsx("td", {
          style: boxStyle,
          children: boxContents
        }), /*#__PURE__*/_jsxs("td", {
          className: Styles.legendTitles,
          children: [legendItem.titleAbove && /*#__PURE__*/_jsx("div", {
            className: Styles.legendTitleAbove,
            children: legendItem.titleAbove
          }), /*#__PURE__*/_jsx("div", {
            title: isDefined(legendItem.multipleTitles) ? legendItem.multipleTitles.join(", ") : legendItem.title,
            children: isDefined(legendItem.multipleTitles) ? "".concat(legendItem.multipleTitles.slice(0, legendItem.maxMultipleTitlesShowed).join(", ")).concat(legendItem.multipleTitles.length > legendItem.maxMultipleTitlesShowed ? "..." : "") : legendItem.title
          }), legendItem.titleBelow && /*#__PURE__*/_jsx("div", {
            className: Styles.legendTitleBelow,
            children: legendItem.titleBelow
          })]
        })]
      })]
    }, i);
  }
  render() {
    if ((!hasTraits(this.props.item, LegendOwnerTraits, "legends") || !hasTraits(this.props.item, LegendOwnerTraits, "hideLegendInWorkbench")) && !TableMixin.isMixedInto(this.props.item)) {
      return null;
    }
    if (hasTraits(this.props.item, LegendOwnerTraits, "hideLegendInWorkbench") && this.props.item.hideLegendInWorkbench || MinMaxLevelMixin.isMixedInto(this.props.item) && this.props.item.scaleWorkbenchInfo) return null;
    if (isDefined(this.props.item.legends) && this.props.item.legends.length > 0) {
      const backgroundColor = hasTraits(this.props.item, LegendOwnerTraits, "legendBackgroundColor") ? this.props.item.legendBackgroundColor : undefined;
      return /*#__PURE__*/_jsx("ul", {
        className: Styles.legend,
        children: /*#__PURE__*/_jsxs(_StyledDiv, {
          className: Styles.legendInner,
          $_css3: backgroundColor,
          children: [
          // Show temporary "legend button" - if custom styling has been applied
          TableMixin.isMixedInto(this.props.item) && this.props.item.legendButton ? /*#__PURE__*/_jsx(_StyledButton, {
            primary: true,
            shortMinHeight: true,
            renderIcon: () => /*#__PURE__*/_jsx(StyledIcon, {
              light: true,
              glyph: Icon.GLYPHS.menuDotted,
              styledWidth: "12px"
            }),
            rightIcon: true,
            iconProps: {
              css: {
                marginRight: 0,
                marginLeft: 4
              }
            },
            onClick: this.props.item.legendButton.onClick.bind(this.props.item),
            children: this.props.item.legendButton.title
          }) : null, this.props.item.legends.map((legend, i) => /*#__PURE__*/_jsxs(Fragment, {
            children: [isDefined(legend.title) ? /*#__PURE__*/_jsx("h3", {
              className: Styles.legendTitle,
              children: legend.title
            }) : null, this.renderLegend.bind(this)(legend, i)]
          }, i))]
        })
      });
    }
    return null;
  }
}, _defineProperty(_Legend, "defaultProps", {
  forPrint: false
}), _Legend)) || _class;
export { Legend as default };
function makeAbsolute(url) {
  if (url instanceof Resource) {
    url = url.url;
  }
  const uri = new URI(url);
  if (uri.protocol() && uri.protocol() !== "http" && uri.protocol() !== "https") {
    return url;
  } else {
    return uri.absoluteTo(window.location.href).toString();
  }
}
var _StyledA = _styled("a")(p => ({
  backgroundColor: p.$_css
}));
var _StyledTable = _styled2("table")(p => ({
  backgroundColor: p.$_css2
}));
var _StyledDiv = _styled3("div")(p => ({
  position: "relative",
  " li": {
    backgroundColor: p.$_css3
  }
}));
var _StyledButton = _styled4(Button).withConfig({
  displayName: "Legend___StyledButton",
  componentId: "sc-o00pvn-0"
})({
  position: "absolute",
  top: 10,
  right: 0
});